import script from "./StampApplyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StampApplyDialog.vue?vue&type=script&setup=true&lang=ts"

import "./StampApplyDialog.vue?vue&type=style&index=0&id=f6d41f42&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d41f42"]])

export default __exports__